import { useEffect } from "react";
import { useSearchParams } from "react-router-dom";

export default function useReferralCode() {
  const [searchParams] = useSearchParams();
  const refCode = searchParams.get("refCode");

  useEffect(() => {
    if (refCode) {
      sessionStorage.setItem("refCode", refCode);
    }
  }, [refCode]);
}
